import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { getImageUrl } from '../../../../utils/imageUrl';

interface ProductSummaryCardsProps {
  totalCount: number;
  activeCount: number;
  inactiveCount: number;
  loading?: boolean;
}

const ProductSummaryCards: React.FC<ProductSummaryCardsProps> = ({
  totalCount,
  activeCount,
  inactiveCount,
  loading = false,
}) => {
  if (loading) {
    return (
      <Row className="mb-4">
        <Col md={4}>
          <Card className="p-3" style={{ backgroundColor: '#E3F2FD', border: 'none' }}>
            <div className="d-flex align-items-center">
              <div style={{ marginRight: '16px' }}>
                <div className="placeholder" style={{ width: '40px', height: '40px', borderRadius: '4px' }}></div>
              </div>
              <div className="flex-grow-1">
                <div className="placeholder mb-2" style={{ height: '24px', width: '60px', borderRadius: '4px' }}></div>
                <div className="placeholder" style={{ height: '16px', width: '120px', borderRadius: '4px' }}></div>
              </div>
            </div>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="p-3" style={{ backgroundColor: '#E8F5E9', border: 'none' }}>
            <div className="d-flex align-items-center">
              <div style={{ marginRight: '16px' }}>
                <div className="placeholder" style={{ width: '40px', height: '40px', borderRadius: '4px' }}></div>
              </div>
              <div className="flex-grow-1">
                <div className="placeholder mb-2" style={{ height: '24px', width: '60px', borderRadius: '4px' }}></div>
                <div className="placeholder" style={{ height: '16px', width: '140px', borderRadius: '4px' }}></div>
              </div>
            </div>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="p-3" style={{ backgroundColor: '#FFEBEE', border: 'none' }}>
            <div className="d-flex align-items-center">
              <div style={{ marginRight: '16px' }}>
                <div className="placeholder" style={{ width: '40px', height: '40px', borderRadius: '4px' }}></div>
              </div>
              <div className="flex-grow-1">
                <div className="placeholder mb-2" style={{ height: '24px', width: '60px', borderRadius: '4px' }}></div>
                <div className="placeholder" style={{ height: '16px', width: '140px', borderRadius: '4px' }}></div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <Row className="mb-4">
      <Col md={4}>
        <Card className="p-3" style={{ backgroundColor: '#E3F2FD', border: 'none' }}>
          <div className="d-flex align-items-center">
            <div style={{ marginRight: '16px' }}>
              <img 
                src={getImageUrl('admin/static-assets/icons/shop-service/product.svg')} 
                alt="Products" 
                style={{ width: '40px', height: '40px' }}
              />
            </div>
            <div className="flex-grow-1">
              <h3 className="mb-0" style={{ fontSize: '24px', fontWeight: 700, color: '#1976D2' }}>
                {totalCount}
              </h3>
              <p className="mb-0" style={{ fontSize: '14px', color: '#1976D2', fontWeight: 500 }}>
                Products in total
              </p>
            </div>
          </div>
        </Card>
      </Col>
      <Col md={4}>
        <Card className="p-3" style={{ backgroundColor: '#E8F5E9', border: 'none' }}>
          <div className="d-flex align-items-center">
            <div style={{ marginRight: '16px' }}>
              <img 
                src={getImageUrl('admin/static-assets/icons/shop-service/product-active.svg')} 
                alt="Active Products" 
                style={{ width: '40px', height: '40px' }}
              />
            </div>
            <div className="flex-grow-1">
              <h3 className="mb-0" style={{ fontSize: '24px', fontWeight: 700, color: '#388E3C' }}>
                {activeCount}
              </h3>
              <p className="mb-0" style={{ fontSize: '14px', color: '#388E3C', fontWeight: 500 }}>
                Active products in total
              </p>
            </div>
          </div>
        </Card>
      </Col>
      <Col md={4}>
        <Card className="p-3" style={{ backgroundColor: '#FFEBEE', border: 'none' }}>
          <div className="d-flex align-items-center">
            <div style={{ marginRight: '16px' }}>
              <img 
                src={getImageUrl('admin/static-assets/icons/shop-service/product-inactive.svg')} 
                alt="Inactive Products" 
                style={{ width: '40px', height: '40px' }}
              />
            </div>
            <div className="flex-grow-1">
              <h3 className="mb-0" style={{ fontSize: '24px', fontWeight: 700, color: '#D32F2F' }}>
                {inactiveCount}
              </h3>
              <p className="mb-0" style={{ fontSize: '14px', color: '#D32F2F', fontWeight: 500 }}>
                Inactive products in total
              </p>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default ProductSummaryCards;
